<template>
  <div>
    <!-- cards -->
    <div class="container">
      <div class="vegcards">
        <h2 style="white-space: pre-wrap">{{ msg }}</h2>
        <div class="row">
          <div
            v-for="(card, index) in filterCards(
              statestate,
              monthmonth,
              card,
              $cards
            )"
            :key="index"
            class="col xl2 vegCard"
            style="padding: 0 20px"
          >
            <div class="card">
              <router-link
                @click="$router.go()"
                :to="{
                  name: 'vegdetail',
                  params: { card: toURL(card.name), state: toURL(statestate) },
                }"
                ><img
                  :src="getImgUrl(card.image)"
                  v-bind:alt="card.image"
                  class="card-image1"
                  loading="lazy"
                  width="195px"
                  height="103px"
              /></router-link>
              <div class="cardTop" style="padding-bottom: 0">
                <router-link
                  :to="{
                    name: 'vegdetail',
                    params: {
                      card: toURL(card.name),
                      state: toURL(statestate),
                    },
                  }"
                  ><h3 class="card_title">{{ card.name }}</h3></router-link
                >
              </div>
              <div class="card-body">
                <router-link
                  :to="{
                    name: 'vegdetail',
                    params: {
                      card: toURL(card.name),
                      state: toURL(statestate),
                    },
                  }"
                  ><p class="card-content">{{ card.desc }}</p></router-link
                >
              </div>
              <div class="card_action">
                <router-link
                  class="btn-outline-primary"
                  :to="{
                    name: 'vegdetail',
                    params: {
                      card: toURL(card.name),
                      state: toURL(statestate),
                    },
                  }"
                  >Seasonality</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listStates } from "@/components/staticFiles/stateLookup.js";
import { listmonths } from "@/components/staticFiles/months.js";
import { getdate } from "@/components/api/getdate.js";
import {
  getbkUrl,
  getImgUrl,
  toURL,
  toURLreverse,
} from "@/components/api/imagepath.js";
import {
  dropdownarrowstate,
  dropdownarrowmonth,
  dropdownarrowcard,
} from "@/components/api/dropdownicons.js";
import { filterCards } from "@/components/api/filtercards.js";
import { geoloc } from "@/components/api/geolocation.js";

export default {
  // passing props from app.vue
  props: ["state", "month"],

  // funcs that catitalizes the 1st letter of prop value
  computed: {
    statestate() {
      if (this.state) {
        return toURLreverse(this.state);
      } else {
        return "Select a State";
      }
    },
    monthmonth() {
      if (this.month) {
        return toURLreverse(this.month);
      } else {
        return "Any Month";
      }
    },
  },

  data() {
    return {
      states: listStates,
      months: listmonths,
      card: "Any Produce",
      msg: "",
      geoloc1: "",

      // imported methods
      getdate: getdate,
      getbkUrl: getbkUrl,
      toURLreverse: toURLreverse,
      dropdownarrowstate: dropdownarrowstate,
      dropdownarrowmonth: dropdownarrowmonth,
      dropdownarrowcard: dropdownarrowcard,
      filterCards: filterCards,
      geoloc: geoloc,
      getImgUrl: getImgUrl,
      toURL: toURL,
    };
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 26px;
}
p.card-content {
  padding: 0 5px 15px 5px;
  margin-bottom: 0;
}
@media (max-width: 530px) {
  p.card-content {
    padding-bottom: 30px;
  }
}
</style>
